import { Container, Image } from "@chakra-ui/react";

export const Error = () => {

    return (
        <Container mt={['200px', '100px']} p={'100px'}>
            <Image src='/images/Error.gif' />
        </Container>
    );
};